import { useTranslations } from "@fenetech/translations";
import React, { useCallback } from "react";
import { Checkbox, Grid, FormControlLabel } from "@mui/material";
import { ICADOperationLayer } from "../../interfaces";
import { LayerTypeEnum } from "../../enums";
import { GlassLayerHelpers } from "../../GlassLayerHelpers";
import { useCADState, useCADActions } from "../../Context/CADContext";
import CADTable, { ITableColumn } from "../CADTable";
import { useState } from "react";
import CADOperationEditorAPI from "../../API/CADOperationEditorAPI";
import { useEffectOnLoad } from "helpers/hooks/useEffectOnLoad";

interface GlassLayerMultiSelectionProps {
}

const GlassLayerMultiSelection: React.FC<GlassLayerMultiSelectionProps> = (props: GlassLayerMultiSelectionProps) => {

  const tm = useTranslations();
  const cadActions = useCADActions();
  const cadState = useCADState();

  const [glassLayers, setGlassLayers] = useState<ICADOperationLayer[]>([]);

  useEffectOnLoad(() => {
    setGlassLayers(GlassLayerHelpers.FlattenGlassLayers(cadState.operationEditor?.layers!));
  });

  const handleLayerClick = useCallback(async (glassLayer: ICADOperationLayer) => {

    const updatedLayer = { ...glassLayer, selected: !glassLayer.selected };

    const updatedGlassLayers = glassLayers.map((layer) =>
      layer.name === glassLayer.name
        ? { ...layer, ...updatedLayer }
        : layer
    );

    const newState = await CADOperationEditorAPI.PostGlassLayerSelectionAsync(updatedGlassLayers);
    cadActions.setOperationEditor(newState);
    setGlassLayers(GlassLayerHelpers.FlattenGlassLayers(newState.layers));

  }, [cadActions, glassLayers]);

  if (glassLayers.length === 1 || cadState.currentLayer?.layerType === LayerTypeEnum.Spacer) {
    return null; //if it's a mono glass layer or spacer (grid operation) don't show the layer selection
  }

  const layerColumns: Array<ITableColumn<ICADOperationLayer>> = [
    {
      headerText: tm.Get("Layers"),
      width: "75%",
      render: (value, row) => {
        return <Grid container alignItems="center" justifyContent="flex-start">
          <FormControlLabel
            control={
              <Checkbox
                sx={(theme) => {
                  return {
                    padding: theme.spacing(.375),
                    marginLeft: theme.spacing(GlassLayerHelpers.GetGlassLayerVisualDepth(cadState.model, row.name) * 4 + .625)
                  };
                }}
                size="small"
                checked={row.selected}
                disabled={glassLayers.length === 1}
                onChange={() => handleLayerClick(row)}
              />
            }
            label={row.name}
          />
        </Grid>
      }
    }
  ];

  return <>
    <CADTable columns={layerColumns} data={glassLayers || []} />
  </>


}
export default GlassLayerMultiSelection;
